























































































































import { Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import validations from "./validations";
import BaseForm from "@/components/Base/Form/BaseForm.vue";

import ModelFactory from "@/model/ModelFactory";
import ReportModel from "@/model/Report";
import ReportApi from "@/api/Report";
import ReportHCP from "./ReportHCP.vue";
import ReportHCO from "./ReportHCO.vue";
import ReportRND from "./ReportRND.vue";
import ReportSummary from "./ReportSummary.vue";
import ReportAdmin from "./ReportAdmin.vue";

const AppStore = namespace("App");
const FormStore = namespace("Form");
const UserStore = namespace("User");

@Component({
  components: {
    ReportHCP,
    ReportHCO,
    ReportRND,
    ReportSummary,
    ReportAdmin
  },
  validations
})
export default class Report extends BaseForm {
  public report: ReportModel = ModelFactory.create("ReportModel");
  public formName: string = "report";
  public formUrl: string = ReportApi.getReportUrl();
  public selectedOrganization: string | number = "";

  @AppStore.State
  public reportYear!: number;

  @FormStore.State
  public formDisabled!: boolean;

  // @AppStore.State
  // public isReportSent!: boolean;

  @AppStore.State
  public canPublishReport!: boolean;

  @AppStore.State
  public organizations!: object;

  @UserStore.Getter
  public isAdmin!: boolean;

  @UserStore.Getter
  public getOrganization!: string;

  @Watch("$v.$anyDirty")
  emitDirty() {
    this.$emit("dirty", this.$v.$anyDirty);
  }

  get organizationName() {
    return (this.organizations as any)[this.getOrganization];
  }

  get isReportSent() {
    return this.report.status === "current";
  }

  created() {
    this.getReport();
  }

  mounted() {
    const year = this.reportYear;

    this.$store.commit("App/setPageTitle", this.organizationName);
    this.$store.commit("App/setPageDescription", `Raport za rok ${year}`);
  }

  async getReport(id?: string | number | undefined) {
    if (!id) {
      id = this.selectedOrganization;
    }
    this.selectedOrganization = id;

    const report: ReportModel = await ReportApi.get(id, { reload: true }).then(
      (res: any) => res
    );

    this.reset();
    this.setReport(report);
  }

  afterSubmit(res: any) {
    if (res && res.data && res.data.object) {
      this.setReport(res.data.object);
    }
  }

  setReport(report: ReportModel) {
    this.report = ModelFactory.create("ReportModel", report);

    const disabled =
      this.report.status == "current" ||
      (this.report.id > 0 && this.getOrganization !== this.report.organization);

    if (!this.report.year) {
      this.report.year = this.reportYear;
    }
    this.report.draft = false;

    this.$store.commit("Form/setDisabled", disabled);
    // this.$store.commit("App/setIsReportSent", disabled);
  }

  unlockRequest() {
    return ReportApi.unlockRequest(this.report.id);
  }

  async unlock() {
    const unlocked = await ReportApi.unlock(this.report.id).then(
      (res: ServerResponse) => res.success
    );

    if (unlocked) {
      this.getReport();
    }
  }
}
